<template>
    <div class="confirmInfo">
        <div class="info">
            <ul class="info-box">
                <li class="info-item">
                    <div class="title">姓名：</div>
                    <div class="value">{{ userInfo.title | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">性别：</div>
                    <div class="value">{{ userInfo.sex_title | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">生日：</div>
                    <div class="value">{{ userInfo.birthday | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">身份证号：</div>
                    <div class="value">{{ userInfo.identity | isEmpty }}</div>
                </li>
                <!-- <li class="info-item">
                    <div class="title">考生号：</div>
                    <div class="value">{{ userInfo.candidate_number | isEmpty }}</div>
                </li> -->
                <li class="info-item">
                    <div class="title">学号：</div>
                    <div class="value">{{ userInfo.student_code | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">民族：</div>
                    <div class="value">{{ userInfo.nation | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">专业：</div>
                    <div class="value">{{ userInfo.profession_title | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">层次：</div>
                    <div class="value">{{ userInfo.level_title | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">学制：</div>
                    <div class="value">{{ userInfo.level_year | isEmpty }}</div>
                </li>
                <li class="info-item">
                    <div class="title">学习形式：</div>
                    <div class="value">{{ userInfo.shape_title | isEmpty }}</div>
                </li>
            </ul>
            <div class="btn-box">
                <el-button type="primary" @click="confirmClick">确认信息</el-button>
                <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {adultStudentGetEnter, adultStudentEnterConfirm} from '@/api/login';
export default {
    name: 'confirmInfo',
    data(){
        return {
            userInfo: {},
        };
    },
    computed: {
        ...mapState("permission", {
            _ENTRANCETYPE: (state) => state._ENTRANCETYPE,  //成教/自考
            enterConfirm: state => state.enterConfirm,   //是否确认信息
            firstLoginVerify: state => state.firstLoginVerify,  //是否第一次登录
            userInfoData: state => JSON.parse(state.userInfo),  //用户信息
            enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
        }),
    },
    created(){
        this.getData();
    },
    methods: {
        // 退出
        async exit() {
            // loginOut(null).then(() => {
            // this.$store.dispatch('permission/setIsGenerateRoutes', '');
            await this.$store.dispatch('permission/logOut');
            // Cookies.remove('token');
            this.$message.success('退出成功');
            this.$router.replace("/Login");

            // });
        },
        // 确认信息
        confirmClick(){
            adultStudentEnterConfirm().then(res => {
                if(res.code == 200){
                    this.$message.success('确认成功');
                    this.$store.dispatch('permission/enterConfirmActions', 1);
                    if(this.firstLoginVerify == 0){
                      this.$router.push({
                        path: "/verify",
                        query: {
                          classId: this.userInfoData.class_info.class_id,
                        },
                      });
                    }else if(this.enterSchoolImgCheck != 2){
                        this.$router.push({
                            path: "/uploadAdmissionPhotos",
                        });
                        return;
                    }else{
                        this.$router.push({
                            name: "home",
                        });
                    }
                }
            });
        },
        getData() {
            adultStudentGetEnter().then(res => {
                if (res.code == 200) {
                    this.userInfo = res.result;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.confirmInfo{
    padding: 20px;
    font-size: 16px;
    .info{
        background-color: #fff;
        padding: 20px;
        width: 500px;
        margin: 0 auto;
        .info-box{
            .info-item{
                height: 50px;
                display: flex;  
                justify-content: center; 
                .title{
                    width: 49%;
                    text-align: right;
                }
                .value{
                    width: 49%;
                    margin-left: 2%;
                }
            }
        }
        .btn-box{
            margin-top: 20px;
            text-align: center;
        }
    }
}
</style>